import request from '../utils/request';

export interface Collaborator {
  id: number;
  target_type: string;
  target_id: number;
  user_id: number;
  user_name?: string;
  user_department?: string;
  created_at: string;
  updated_at?: string;
}

export interface CollaboratorCreate {
  target_type: string;
  target_id: number;
  user_id: number;
}

/**
 * Add collaborator
 */
export const addCollaborator = (data: CollaboratorCreate): Promise<Collaborator> => {
  return request.post('/collaborators/add', data);
};

/**
 * Get entity collaborators
 */
export const getEntityCollaborators = (
  targetType: string,
  targetId: number
): Promise<Collaborator[]> => {
  return request.get(`/collaborators/entity/${targetType}/${targetId}`);
};

/**
 * Remove collaborator
 */
export const removeCollaborator = (
  userId: number,
  targetType: string,
  targetId: number
): Promise<{ message: string }> => {
  return request.delete('/collaborators/remove', {
    params: { user_id: userId, target_type: targetType, target_id: targetId },
  });
};
